module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAQBJREFUSEvtljFuwlAMhj8zcotyCHa6de1Gj9CdIRIplXgw9BqIrQtcB6ousHcpG3GV0AEiwrMTxES2KNb35befnAhjnSG8AC1s1xZIGMqssjzoK/BAmzch6N4Bz5k7lCWp9M8KxvqBMCieCf1coMXNUMQW4ELVKXwDdK8nKMMzHklldR1BBfzQpaYtugBvLojAmwkM8PoCI7yeoAxv0SORddXh9Q3ZAw/6CSzsAg88jxP0F+HHJvDCD4JiQ8QFdeBmwURHKO//i2tDZKAngzYlCPoFdBB8cEeCJ5RnlCmpfLu2rSmBi1gqvgui3btli7wf/ejLHxVkUuO3xSrIgPkfZC3FKjv4Tj0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/userInfo/customerManage/edit_select.png
// module id = I+Or
// module chunks = 1